import React, { useMemo } from "react";
import { pickIndexStripRows, formatIndexStripRowDisplay } from "utils/indexStripRows";

function IndexStripBox({ title, row }) {
  const d = formatIndexStripRowDisplay(row, title);
  return (
    <div className="nifty_box mb-2">
      <div className="nifty_box__inner">
        <span className="nifty_box__label">{title}</span>
        <div className="nifty_box__values">
          <span className="nifty_box__ltp" style={{ color: d.colorLTP }}>
            {d.ltpText}
          </span>
          <p className={`nifty_box__chg ${d.chgClass || ""}`}>
            {d.isUp ? (
              <i className={`material-icons-outlined small ${d.chgClass} align-bottom`}>
                arrow_drop_up
              </i>
            ) : d.isDown ? (
              <i className={`material-icons-outlined small ${d.chgClass} align-bottom`}>
                arrow_drop_down
              </i>
            ) : (
              <i
                className="material-icons-outlined small align-bottom"
                style={{ color: "#6b7280" }}
              >
                remove
              </i>
            )}
            <span>
              {d.deltaText}({d.pctText}%)
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

/** NIFTY 50 / B NIFTY / SENSEX strip — same slots and % logic as mobile. */
export default function MarketWatchIndexStrip({ scriptIndexList, className = "" }) {
  const { nifty, bankNifty, sensex } = useMemo(
    () => pickIndexStripRows(scriptIndexList),
    [scriptIndexList]
  );

  return (
    <div className={`nifty_wrapper${className ? ` ${className}` : ""}`}>
      <IndexStripBox title="NIFTY 50" row={nifty} />
      <IndexStripBox title="B NIFTY" row={bankNifty} />
      <IndexStripBox title="SENSEX" row={sensex} />
    </div>
  );
}
